import { NAV_ICONS } from "../components/ui/icons";

export const PLATFORM_BOTTOM_TABS = [
  { id: "overview", to: "/admin", end: true, label: "Сводка", icon: "overview" },
  { id: "tenants", to: "/admin/tenants", label: "Клубы", icon: "clients" },
  { id: "support", to: "/admin/support", label: "Чат", icon: "chat" },
  { id: "more", to: "/admin/more", label: "Ещё", icon: "settings" },
];

export const PLATFORM_MORE_LINKS = [
  { id: "payments", to: "/admin/payments", label: "Оплаты клубов", icon: "finance" },
  { id: "plans", to: "/admin/plans", label: "Тарифы SaaS", icon: "memberships" },
  { id: "notifications", to: "/admin/notifications", label: "Уведомления", icon: "notifications" },
  { id: "audit", to: "/admin/audit", label: "Журнал аудита", icon: "journal" },
  { id: "tenants", to: "/admin/tenants", label: "Все клубы", icon: "clients" },
  { id: "support", to: "/admin/support", label: "Поддержка", icon: "chat" },
];

export function resolvePlatformBottomTab(pathname) {
  const path = String(pathname || "").replace(/\/$/, "") || "/admin";
  if (path === "/admin" || path === "/admin/") return "overview";
  if (path.startsWith("/admin/tenants")) return "tenants";
  if (path.startsWith("/admin/support")) return "support";
  if (
    path.startsWith("/admin/more") ||
    path.startsWith("/admin/plans") ||
    path.startsWith("/admin/audit") ||
    path.startsWith("/admin/payments") ||
    path.startsWith("/admin/notifications")
  ) {
    return "more";
  }
  return "overview";
}

export function isPlatformChatConversation(pathname) {
  const path = String(pathname || "");
  return /^\/admin\/support\/[^/]+/.test(path);
}

export function platformNavIcon(key) {
  return NAV_ICONS[key] || NAV_ICONS.overview;
}
